export const preferencesKeys = {
  all: () => ['preferences'] as const,
  key: (boardId: number, key: string) =>
    [...preferencesKeys.all(), { boardId, key }] as const,
};
